import React, { useState } from 'react';
import axios from 'axios';
import { Star } from '@phosphor-icons/react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Owner-only toggle that flips `event.public_showcase`. When ON the
// event becomes eligible for the homepage Live Moments marquee + any
// future social clip / highlight reel recycling pipelines. Default is
// off — most paying customers expect privacy by default; surfacing
// their event name publicly is opt-in only.
//
// Lives on the organiser dashboard header next to the Share button.
// Single PATCH per click; the dashboard then refetches to keep state
// in sync (passed via `onUpdate`).
const FeatureEventToggle = ({ event, onUpdate }) => {
  const [busy, setBusy] = useState(false);
  const on = !!event?.public_showcase;

  const toggle = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const token = localStorage.getItem('access_token');
      await axios.patch(
        `${API}/events/${event.event_id}/showcase`,
        { public_showcase: !on },
        { headers: token ? { Authorization: `Bearer ${token}` } : {} },
      );
      toast.success(on ? 'Removed from homepage Live Moments' : 'Now eligible for homepage Live Moments ✨');
      if (onUpdate) await onUpdate();
    } catch {
      toast.error('Could not update showcase setting');
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={toggle}
      disabled={busy}
      className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium transition-all"
      style={{
        background: on
          ? 'linear-gradient(135deg, rgba(255,107,203,0.18), rgba(184,151,98,0.18))'
          : 'rgba(255,255,255,0.03)',
        border: on
          ? '1px solid rgba(255,107,203,0.45)'
          : '1px solid rgba(255,255,255,0.1)',
        color: on ? '#FF6BCB' : 'rgba(255,255,255,0.65)',
        opacity: busy ? 0.6 : 1,
      }}
      data-testid="feature-event-toggle"
      title={on
        ? 'This event is featured on the EventDrop homepage Live Moments strip. Tap to make private.'
        : 'Feature this event publicly. Eligible for homepage Live Moments + social clips.'}
    >
      <Star size={14} weight={on ? 'fill' : 'bold'} />
      {on ? 'Featured' : 'Feature this event'}
    </button>
  );
};

export default FeatureEventToggle;
export { FeatureEventToggle };
